import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import getUsageTracker from 'pricing-pages-lib/utils/getUsageTracker';
import { createToObject } from 'pricing-pages-lib/utils/queryParamUtils';
import { useCallback, useEffect, useMemo } from 'react';
import { Redirect } from 'react-router-dom';
import { ERROR_SEVERITY } from '../components/error-boundary/error-severity';
import { useErrorBoundary } from '../components/error-boundary/useErrorBoundary';
import withErrorBoundary from '../components/error-boundary/withErrorBoundary';
import HeaderLayoutWrapper from '../components/layout/HeaderLayoutWrapper';
import RecommendedSalesHubProContainer from '../components/recommended/RecommendedSalesHubProContainer';
import RecommendedStarterCustomerPlatformContainer from '../components/recommended/RecommendedStarterCustomerPlatformContainer';
import { RECOMMENDED_PAGE } from '../constants/ErrorBoundaryNames';
import { OWNERSHIP_CHECK_FAILED, PRICING_AND_PURCHASING_FAILED_STATUS } from '../constants/ErrorCauses';
import { NavItemEnum } from '../constants/routing/NavItems';
import { useAnchorLinkScroll } from '../hooks/htmlElementHooks';
import { useGlobalLoading } from '../hooks/loadingHooks';
import { useDocumentTitle } from '../hooks/useDocumentTitle';
import {
// useIsRecommendedSalesHubPro,
useIsRecommendedStarterCustomerPlatform, useRecommendedProduct } from '../hooks/useRecommendations';
import { useRedirectIfIneligible } from '../hooks/useRedirectIfIneligible';
import { useAppSelector } from '../reducers';
import { isUngatedForRecommendedViewSelector } from '../selectors/GatingSelectors';
import { hasGatesLoadedSelector, hasOnlyOwnershipCheckFailedSelector, hasPricingAndPurchasingFailedSelector } from '../selectors/LoadingStateSelectors';
import { trackPageView } from '../utils/tracking/trackingEventUtils';
import { useQueryParamTerm, useQueryParamsEffect } from '../utils/urls/appQueryParamUtils';
import { jsx as _jsx } from "react/jsx-runtime";
const RecommendedPage = () => {
  useAnchorLinkScroll();
  useDocumentTitle('recommended');
  const navItem = NavItemEnum.RECOMMENDED;
  const {
    queryParamTerm
  } = useQueryParamTerm();
  useQueryParamsEffect({
    term: queryParamTerm
  });
  const isAppReady = useGlobalLoading();
  const hasGatesLoaded = useAppSelector(hasGatesLoadedSelector);
  const hasPricingAndPurchasingFailed = useAppSelector(hasPricingAndPurchasingFailedSelector);
  const hasOnlyOwnershipCheckFailed = useAppSelector(hasOnlyOwnershipCheckFailedSelector);
  const {
    showBoundary
  } = useErrorBoundary();
  // const { isSSM0010Loading } = useSSM0010Experiment();

  const {
    loading: recommendedProductLoading
  } = useRecommendedProduct();
  const isUngatedForRecommendedView = useAppSelector(isUngatedForRecommendedViewSelector);
  const isRecommendedStarterCustomerPlatform = useIsRecommendedStarterCustomerPlatform();

  // const isRecommendedSalesHubPro = useIsRecommendedSalesHubPro();

  const recommendOverride = useMemo(() => new URLSearchParams(window.location.search).get('recommend'), []);
  useEffect(() => {
    getUsageTracker().setProperties({
      defaultedTab: '',
      tab: ''
    });
    trackPageView({
      screen: navItem
    });
  }, [navItem]);
  const redirectCondition = useCallback(() => {
    if (!hasGatesLoaded || recommendedProductLoading) {
      return;
    }
    return !isUngatedForRecommendedView;
  }, [hasGatesLoaded, recommendedProductLoading, isUngatedForRecommendedView]);
  useRedirectIfIneligible({
    condition: redirectCondition
  });
  if (hasPricingAndPurchasingFailed) {
    if (hasOnlyOwnershipCheckFailed) {
      showBoundary(new Error(OWNERSHIP_CHECK_FAILED));
    }
    showBoundary(new Error(PRICING_AND_PURCHASING_FAILED_STATUS));
  }
  if (!isAppReady || !hasGatesLoaded ||
  // isSSM0010Loading ||
  recommendedProductLoading) {
    return /*#__PURE__*/_jsx(LoadingSpinner, {
      minHeight: 200,
      size: "md",
      grow: true
    });
  }
  const renderRecommendedProductPage = () => {
    if (recommendOverride === 'suite') {
      return /*#__PURE__*/_jsx(RecommendedStarterCustomerPlatformContainer, {});
    }
    if (recommendOverride === 'sales') {
      return /*#__PURE__*/_jsx(RecommendedSalesHubProContainer, {});
    }
    if (isRecommendedStarterCustomerPlatform) {
      return /*#__PURE__*/_jsx(RecommendedStarterCustomerPlatformContainer, {});
    }
    // if (isRecommendedSalesHubPro) {
    return /*#__PURE__*/_jsx(RecommendedSalesHubProContainer, {});
    // }
    // Log an issue here
    // return null;
  };

  // TODO: we should not render a successful nav marker if the null is returned from renderRecommendedProductPage
  return /*#__PURE__*/_jsx(HeaderLayoutWrapper, {
    navItem: navItem,
    navMarkerName: "RECOMMENDED_PAGE",
    children: renderRecommendedProductPage()
  });
};
export default withErrorBoundary(RecommendedPage, {
  fallback: /*#__PURE__*/_jsx(Redirect, {
    to: createToObject('/suite')
  }),
  errorBoundaryName: RECOMMENDED_PAGE,
  severity: ERROR_SEVERITY.HIGH
});